import {Button, Form, Input} from 'antd';
import {jwtDecode} from 'jwt-decode';
import {useState} from 'react';
import {toast} from 'react-hot-toast';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {RQUserLoginAPI} from '../../../reactQuery/apis/rqAuthAPI';
import {loginSuccess} from '../../../redux/authAction/authAction';
import {ForgotPasswordScreen} from '../LoginScreen/ForgetPasswordScreen'; 

const LoginScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const {mutate: loginUser, isLoading} = RQUserLoginAPI({
    onSuccess: res => {
      if (res?.token) {
        const decoded = jwtDecode(res.token);

        dispatch(loginSuccess({...res, role: decoded.role}));

        toast.success('Login successful');

        if (decoded.role === 'ADMIN') {
          navigate('/admin/dashboard');
        } else if (decoded.role === 'ACCOUNTANT') {
          navigate('/accountant/dashboard');
        } else if (decoded.role === 'SUPERVISOR') {
          navigate('/supervisor/dashboard');
        }
      }
    },
    onError: err => {
      if (err?.response?.status === 401) {
        toast.error('Invalid email or password');
      } else if (!err?.response) {
        toast.error('Network error, check connection');
      } else {
        toast.error('Invalid credentials');
      }
    },
  });

  if (showForgotPassword) {
    return <ForgotPasswordScreen setShowForgotPassword={setShowForgotPassword} />;
  }

  const onFinish = values => {
    loginUser(values);
  };

  return (
    <div className={'w-full m-4 pr-8 max-w-sm'}>
      <h2 className={'md:text-2xl md:flex hidden text-xl font-bold text-primary-950 text-center items-center mt-8 mb-6'}>
            SIGN IN TO CONTINUE
      </h2>
      <Form layout={'vertical'} onFinish={onFinish}>
        <Form.Item
          label={'Email'}
          name={'email'}
          rules={[
            {required: true, message: 'Email is required'},
            {type: 'email', message: 'Enter valid email'},
          ]}
        >
          <Input placeholder={'Enter email'} />
        </Form.Item>

        <Form.Item
          label={'Password'}
          name={'password'}
          className={'mb-0'}
          rules={[
            {required: true, message: 'Password is required'},
          ]}
        >
          <Input.Password placeholder={'Enter password'} />
        </Form.Item>
        
        <div className={'text-right mb-4'}>
          <Button
            type={'link'}
            onClick={() => setShowForgotPassword(true)}
          >
                Forgot Password?
          </Button>
        </div>

        <Button
          type={'primary'}
          htmlType={'submit'}
          loading={isLoading}
          block
          className={'bg-primary-800 hover:!bg-primary-900'}
        >
          Login
        </Button>
      </Form>
    </div>
  );
};

export default LoginScreen;
